import React, { useState, useEffect, useRef } from 'react'
import { TextField,
    Accordion,
    AccordionDetails,
    Button,
    Typography,
    CircularProgress,
    Tooltip,
    InputAdornment,
    IconButton,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Divider,
} from '@material-ui/core'
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
import SearchIcon from '@material-ui/icons/Search'
import TextRotationNoneSharpIcon from '@material-ui/icons/TextRotationNoneSharp'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import DateFnsUtils from '@date-io/date-fns'
import esLocale from "date-fns/locale/es"
import 'date-fns'
import { useDispatch, useSelector } from 'react-redux'
import { generate_Token, savePadreBD } from '../../redux/thunk/padreThunk'
import { Alerta } from '../../controls/Alerta'
import { Mensaje } from '../../controls/Mensaje'
import { TextNumber } from '../../controls/TextNumber'
import { useStyles, StyledAccordionSummary, StyledTextField } from './RegistroPadreStyle'
import { Formik, useField, useFormikContext } from 'formik'
import ProfileSchema from './registroPadreProfile'
import { getCaptchaSR } from '../../redux/thunk/captchaThunk'
import { validCodigoVerificacion, updatePadre } from '../../redux/actions/padreActions'
import { updateDato } from '../../redux/actions/estudianteActions'

import { getTiposDocumentoBD } from '../../redux/thunk/parametroThunk'

import { StyledAccordionActions } from './../estudiante/RegistroEstudianteStyle'
import { updateInfoBasica } from '../../redux/actions/informacionBasicaActions'
import MoreVertIcon from '@material-ui/icons/MoreVert';

const { niveles } = require("../../data/params")

export const RegistroPadreScreen = ( ) => {
    const classes = useStyles();
    
    const dispatch = useDispatch()
    const padre = useSelector( state => state.padre )
    const captcha = useSelector( state => state.captcha )
    const tipos_documento = useSelector( state => state.tipos_documento )
    const informacion_basica = useSelector( state => state.informacion_basica )

    const { generos } = require("../../data/params")

    const [alert, setAlert] = useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: '',
        severity: 'success'
    });

    const [isLooked, setIsLooked] = useState(false)
    const [expanded, setexpanded] = useState(true)

    
    useEffect(() => {
        if (!isLooked) {
            setIsLooked( true )
            dispatch( generate_Token() ) 
            dispatch( getCaptchaSR() )
            dispatch( getTiposDocumentoBD() )
    
            dispatch( updateInfoBasica( {miembro: '' } ) )
            dispatch( updateInfoBasica( {cargo: '007' } ) )
            
            localStorage.removeItem('tipo_envio');
            localStorage.removeItem('nombre_formato_vee');
            localStorage.removeItem('id_formato_selected');
            localStorage.removeItem('arr_id_formato_registrados');
        }
    }, [ isLooked, dispatch ])

    const handleCloseAlert = () => {
        setAlert({ ...alert, open: false });
    };

    const messageActive = useRef( padre.message )

    useEffect(() => {

        if ( padre.message !== '' && padre.severity === 'error' && !captcha.isLoading )
        {
            // setAlert({ ...alert, open: true, message: padre.message, severity: padre.severity });
            Mensaje(`
                ${
                    padre.message
                }
                <br>
            `, '¡Validación!', 'error')

            dispatch( getCaptchaSR() )
            dispatch( validCodigoVerificacion( { message: '' } ) )
            messageActive.current = padre.message
        }
        if ( padre.message !== messageActive.current && padre.severity === 'success' )
        {
            // if (padre.id_veeduria != '0') {
            //     Mensaje('Ud. ya registró su veeduría.<br>Si continúa, se actualizarán los datos ingresados.', '¡Aviso!', 'info', true)
            // }
            // else{
            //     setAlert({ ...alert, open: true, message: padre.message, severity: padre.severity });
            //     messageActive.current = padre.message;
            // }
            
            setAlert({ ...alert, open: true, message: padre.message, severity: padre.severity });
            messageActive.current = padre.message;
        }
    }, [ padre, alert, dispatch, captcha ])


    const MyField = props => {
        const {
            setFieldValue,
        } = useFormikContext();
        const [field, meta] = useField(props);
    
        useEffect(() => {
            let isCurrent = true;
            // INICIO: Con captcha
            if ( padre.codigo_verificacion.toLowerCase() !== captcha.codigo.toLowerCase()
            && !padre.isLoading ) {
                if (!!isCurrent) {
                    setFieldValue(props.name, '');
                    setFieldValue('codigo_verificacion', '');
                }
            }
            else if ( padre.nombre_completo !== '' && !padre.isLoading ) {
                if (!!isCurrent) {
                    setFieldValue(props.name, padre.nombre_completo);
                    if (padre.celular)
                    {
                        setFieldValue('celular', padre.celular);
                    }
                }
            }
            // FIN: Con captcha

            // // INICIO: Sin captcha
            // if ( padre.nombre_completo !== '' && !padre.isLoading ) {
            //     if (!!isCurrent) {
            //         setFieldValue(props.name, padre.nombre_completo);
            //         if (padre.celular)
            //         {
            //             setFieldValue('celular', padre.celular);
            //         }
            //     }
            // }
            // // FIN: Sin captcha

            return () => {
                isCurrent = false;
            };
        }, [ setFieldValue, props.name ]);
        
        return (
        <>
            <StyledTextField
            disabled
            // helperText="Éste dato se obtiene de RENIEC"
            fullWidth 
            size="small"
            variant="outlined" 
            label="Nombres y apellidos"
            className={ classes.textDisabled }
            {...props} {...field}
            />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
        );
    };


    const MyPhone = props => {
        const {
            setFieldValue,
        } = useFormikContext();
        const [field, meta, handleBlur, value] = useField(props);
    
        useEffect(() => {
            console.log(value)
            let isCurrent = true;
            if ( padre.nombre_completo !== '' && !padre.isLoading ) {
                if (!!isCurrent) {
                    if (padre.celular)
                    {
                        setFieldValue('celular', padre.celular);
                    }
                }
            }

            return () => {
                isCurrent = false;
            };
        }, [ setFieldValue, props.name ]);
        
        return (
        <>
            <TextField className = { classes.inputStyle}
            fullWidth 
            size="small"
            id="celular"
            name="celular"
            label="Celular"
            onBlur={ handleBlur }
            InputProps={ { inputComponent: TextNumber } }
            autoComplete="off"
            {...props} {...field}
            />
            {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
        </>
        );
    };


    return (
        <Formik
        initialValues={ padre }
        validationSchema={ ProfileSchema }
        onSubmit={ ( values, { setSubmitting }) => {
            const payload = {
                tipo_doc_padre: values.tipo_doc_padre, 
                dni: values.dni, 
                nombre: values.nombre,
                apellido_paterno: values.apellido_paterno, 
                apellido_materno: values.apellido_materno,
                fecha_emision: values.fecha_emision, 
                codigo_verificacion: values.codigo_verificacion, 
                celular: values.celular,
                genero: values.genero
            }
            dispatch( savePadreBD( payload ) ) 
            setTimeout(() => {
                setSubmitting(false)
            }, 5000);
        } }
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                isValid,
                setFieldValue
            }) => (
                
                <form 
                className={ classes.form }
                autoComplete="off"
                id="frm-padre"
                onSubmit={ handleSubmit } >
                    <Accordion expanded={ expanded } id="acordion" onChange={ () => { setexpanded( !expanded ) } }>
                        <StyledAccordionSummary aria-controls="panel1a-content" id="panel1a-hea"
                        expandIcon={ <ExpandMoreIcon className={ classes.iconExpander }/> } >
                            <Typography className={ classes.heading }>
                                {/* Datos del { informacion_basica.cargo_nombre } */}
                                Datos del padre/madre de familia
                            </Typography>
                        </StyledAccordionSummary>
                        <AccordionDetails className={ classes.detalle }>

                            <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-4 lg-grid-12">
                                <div className="s-y-1 s-x-1 s-cols-2 
                                                m-y-1 m-x-1 m-cols-1
                                                l-y-1 l-x-1 l-cols-2">  
                                    <div className={ classes.wrapper }>
                                        <FormControl className={ classes.formControl }
                                        // className={ classes.selectStyle }
                                        fullWidth
                                        size="small"
                                        id="form-tipo-doc-padre"
                                        name="tipo_doc_padre"
                                        variant="outlined"
                                        error={ touched.tipo_doc_padre && Boolean( errors.tipo_doc_padre ) }
                                        >
                                            <InputLabel id="tipo-documento-label" className={ classes.heading }>
                                                Tipo documento
                                            </InputLabel>
                                            <Select 
                                            labelId="tipo-documento-label"
                                            id="tipo-documento-select-outlined"
                                            label="Tipo documento"
                                            className={ classes.selectStyle }
                                            value={ padre.tipo_doc_padre }
                                            // value={ values.tipo_doc_padre }
                                            onBlur={ handleBlur( 'tipo_doc_padre' ) }
                                            // disabled={ tipos_documento.isLoading || padre.nombre_completo?.length > 0 || padre.isValidated || informacion_basica.cargo != '007' }
                                            // disabled={ tipos_documento.isLoading }
                                            disabled={ padre.isValidated }
                                            onChange={ e => {
                                                const { value } = e.target
                                                setFieldValue( "tipo_doc_padre", value )
                                                setFieldValue( "nombre", (value === '0101') ? 'value' : '' )
                                                setFieldValue( "apellido_paterno", (value === '0101') ? 'value' : '' )
                                                setFieldValue( "apellido_materno", (value === '0101') ? 'value' : '' )
                                                setFieldValue( "dni", '' )
                                                setFieldValue("generos", generos);
                                                dispatch( updatePadre( {tipo_doc_padre: value} ) )
                                            } }
                                            >
                                                {
                                                    tipos_documento.listado.map( ( opt, i) => (
                                                        <MenuItem className={ classes.selectStyle } key={ i } value={ opt.PARAMETRO_COD }>{ opt.PARAMETRO_DES }</MenuItem>
                                                    ) )
                                                }
                                            </Select>
                                            {
                                                touched.tipo_doc_padre
                                                ? <FormHelperText className={ classes.selectStyle } >{ errors.tipo_doc_padre }</FormHelperText>
                                                : null
                                            }
                                        </FormControl>
                                        { tipos_documento.isLoading && <CircularProgress size={ 20 } className={ classes.autocompleteProgress } /> }
                                    </div>
                                </div>
                                <div className="s-y-2 s-x-1 s-cols-2 
                                                m-y-1 m-x-2 m-cols-1
                                                l-y-1 l-x-3 l-cols-2">  
                                    {
                                        (values.tipo_doc_padre === '0101' || (values.tipo_doc_padre === '0105' && values.tipo_doc_padre !== ''))
                                        &&
                                            <TextField className={ classes.inputStyle } 
                                            fullWidth
                                            size="small"
                                            label="Nro. documento"
                                            variant="outlined"
                                            name="dni"
                                            id={ values.tipo_doc_padre === '0101' ? "dni" : "ruc"}
                                            value={ values.dni }
                                            onBlur={ handleBlur }
                                            onChange={ handleChange }
                                            // onChange={(event) => {
                                            //     if(event.target.value.length == 8) {
                                            //         console.log(event.target.value)
                                            //         setFieldValue("dni", event.target.value);
                                            //         dispatch( updatePadre( {dni: event.target.value } ) )
                                            //     }
                                            // }}
                                            helperText={ touched.dni ? errors.dni : ""}
                                            error={ touched.dni && Boolean( errors.dni ) }
                                            InputProps={ { inputComponent: TextNumber } }
                                            disabled={ padre.nombre_completo?.length > 0 || padre.isValidated }
                                            />
                                    }
                                    {
                                        values.tipo_doc_padre !== '0101' && values.tipo_doc_padre !== '0105' && values.tipo_doc_padre !== ''
                                        &&
                                            <TextField className={ classes.inputStyle } 
                                            fullWidth 
                                            size="small"
                                            label="Nro. documento"
                                            variant="outlined"
                                            name="dni"
                                            autoComplete="off"
                                            value={ values.dni }
                                            onBlur={ handleBlur }
                                            helperText={ touched.dni ? errors.dni : "" }
                                            error={ touched.dni && Boolean( errors.dni ) }
                                            disabled={ padre.isValidated }
                                            inputProps={ { style: { textTransform: 'uppercase' }, maxLength: 12 } }
                                            onChange={(event) => {
                                                const regex = /^([a-z0-9]+)$/i;
                                                if (event.target.value === '' || regex.test(event.target.value)) {
                                                    setFieldValue("dni", event.target.value);
                                                }
                                            }}

                                            />
                                    }
                                </div>
                                <div className={`${values.tipo_doc_padre === '0101'
                                                ? 
                                                    "s-y-3 s-x-1 s-cols-2    m-y-1 m-x-3 m-cols-2    l-y-1 l-x-5 l-cols-2"
                                                : 
                                                    "s-y-3 s-x-1 s-cols-2    m-y-2 m-x-1 m-cols-1    l-y-1 l-x-5 l-cols-1"}`}>
                                    {
                                        values.tipo_doc_padre === '0101'
                                        ?   
                                            <MuiPickersUtilsProvider utils={ DateFnsUtils } locale={ esLocale }
                                            variant="outlined"
                                            disabled={ padre.nombre_completo?.length > 0 } >
                                                <KeyboardDatePicker
                                                disableFuture
                                                clearable
                                                invalidDateMessage="Fecha incorrecta."
                                                variant="inline"
                                                inputVariant="outlined"
                                                maxDateMessage="No puede ser mayor a hoy"
                                                openTo="year"
                                                format="dd/MM/yyyy"
                                                className={ classes.inputStyle } //agregado
                                                clearLabel="borrar"
                                                cancelLabel="cancelar"
                                                okLabel="aceptar"
                                                label="Fecha emisión DNI"
                                                views={ ["year", "month", "date"] }
                                                disabled={ padre.nombre_completo?.length > 0 }
                                                fullWidth
                                                size="small"
                                                name="fecha_emision"
                                                value={ values.fecha_emision }
                                                onChange={ value => setFieldValue( "fecha_emision", value ) }
                                                KeyboardButtonProps={ { "aria-label": "change date" } }
                                                onBlur={ handleBlur }
                                                helperText={ touched.fecha_emision ? errors.fecha_emision : "" }
                                                error={ touched.fecha_emision && Boolean( errors.fecha_emision ) }
                                                />
                                            </MuiPickersUtilsProvider>
                                        :   
                                            values.tipo_doc_padre === '0102' || values.tipo_doc_padre === '0103' || values.tipo_doc_padre === '0104' || values.tipo_doc_padre === '0105'
                                            ?   
                                                <TextField
                                                fullWidth 
                                                size="small"
                                                label="Nombres"
                                                variant="outlined"
                                                name="nombre"
                                                autoComplete="off"
                                                value={ values.nombre }
                                                onBlur={ handleBlur }
                                                helperText={ touched.nombre ? errors.nombre : "" }
                                                error={ touched.nombre && Boolean( errors.nombre ) }
                                                inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                                disabled={ padre.isValidated }
                                                onChange={(event) => {
                                                    const regex = /^([a-zñáéíóú ]+)$/i;
                                                    if (event.target.value === '' || regex.test(event.target.value)) {
                                                        setFieldValue("nombre", event.target.value);
                                                    }
                                                }}
                                                className={ classes.inputStyle } //agregado
                                                />
                                            :   
                                                null
                                    }
                                </div>
                                {
                                    values.tipo_doc_padre === '0102' || values.tipo_doc_padre === '0103' || values.tipo_doc_padre === '0104' || values.tipo_doc_padre === '0105'
                                    ?
                                        <>
                                            <div className="s-y-4 s-x-1 s-cols-2
                                                            m-y-2 m-x-2 m-cols-1
                                                            l-y-1 l-x-6 l-cols-2">
                                                <TextField
                                                fullWidth 
                                                size="small"
                                                label="Apellido paterno"
                                                name="apellido_paterno"
                                                variant="outlined"
                                                autoComplete="off"
                                                value={ values.apellido_paterno }
                                                onBlur={ handleBlur }
                                                helperText={ touched.apellido_paterno ? errors.apellido_paterno : "" }
                                                error={ touched.apellido_paterno && Boolean( errors.apellido_paterno ) }
                                                inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                                disabled={ padre.isValidated }
                                                onChange={(event) => {
                                                    const regex = /^([a-zñáéíóú ]+)$/i;
                                                    if (event.target.value === '' || regex.test(event.target.value)) {
                                                        setFieldValue("apellido_paterno", event.target.value);
                                                    }
                                                }}
                                                className={ classes.inputStyle } //agregado
                                                />
                                            </div>
                                            <div className="s-y-5 s-x-1 s-cols-2
                                                            m-y-2 m-x-3 m-cols-1
                                                            l-y-1 l-x-8 l-cols-2">
                                                <TextField
                                                fullWidth 
                                                size="small"
                                                label="Apellido materno"
                                                name="apellido_materno"
                                                variant="outlined"
                                                autoComplete="off"
                                                value={ values.apellido_materno }
                                                onBlur={ handleBlur }
                                                helperText={ touched.apellido_materno ? errors.apellido_materno : "" }
                                                error={ touched.apellido_materno && Boolean( errors.apellido_materno ) }
                                                inputProps={ { style: { textTransform: 'capitalize' }, maxLength: 50 } }
                                                disabled={ padre.isValidated }
                                                onChange={(event) => {
                                                    const regex = /^([a-zñáéíóú ]+)$/i;
                                                    if (event.target.value === '' || regex.test(event.target.value)) {
                                                        setFieldValue("apellido_materno", event.target.value);
                                                    }
                                                }}
                                                className={ classes.inputStyle } //agregado
                                                />
                                            </div>
                                            
                                            <div className="s-y-6 s-x-1 s-cols-2    m-y-2 m-x-4 m-cols-1    l-y-1 l-x-10 l-cols-2">
                                                <FormControl  className={ classes.formControl } 
                                                fullWidth
                                                size="small"
                                                id="form-genero"
                                                name="genero"
                                                variant="outlined"
                                                error={ touched.genero && Boolean( errors.genero ) }
                                                >
                                                    <InputLabel id="genero-label" className={ classes.selectStyle} >
                                                        Género
                                                    </InputLabel>
                                                    <Select className={ classes.selectStyle} 
                                                    value={ values.genero }
                                                    labelId="genero-label"
                                                    id="genero"
                                                    name="genero"
                                                    disabled={ padre.isValidated }
                                                    label="Género"
                                                    onChange={e => {
                                                        const { value } = e.target
                                                        setFieldValue( "genero", value )
                                                    }}
                                                    >
                                                    {
                                                        values.generos
                                                        ?
                                                            values.generos.map( item => (
                                                                <MenuItem  className={ classes.selectStyle} key={ item.cod } value={ item.cod }>{ item.des }</MenuItem>
                                                            ) )
                                                        :
                                                            <MenuItem className={ classes.selectStyle} value="" disabled> No existen registros </MenuItem>
                                                    }
                                                    </Select>
                                                    {
                                                        touched.genero
                                                        ? <FormHelperText className={ classes.selectStyle} >{ errors.genero }</FormHelperText>
                                                        : null
                                                    }
                                                </FormControl>
                                            </div>
                                        </>
                                    :
                                        null
                                }
                                {
                                    padre.nombre_completo?.length === 0
                                    ?
                                        <>
                                            <div className={`${values.tipo_doc_padre === '0101'
                                                ? 
                                                    "s-y-4 s-x-1 s-cols-1    m-y-2 m-x-1 m-cols-1    l-y-1 l-x-7 l-cols-2"
                                                : 
                                                    "s-y-7 s-x-1 s-cols-1    m-y-3 m-x-1 m-cols-1    l-y-2 l-x-6 l-cols-2"}`}>
                                                {
                                                    values.tipo_doc_padre !== ''
                                                    ?
                                                        <TextField
                                                        fullWidth
                                                        size="small"
                                                        label="Código"
                                                        name="codigo_verificacion"
                                                        variant="outlined"
                                                        value={ values.codigo_verificacion }
                                                        // InputProps={{
                                                        //     endAdornment: <InputAdornment position="end">
                                                        //         <IconButton>
                                                        //             <TextRotationNoneSharpIcon />
                                                        //         </IconButton>
                                                        //     </InputAdornment>,
                                                        // }}
                                                        inputProps={ { maxLength: 4, style: { textTransform: 'uppercase' } } }
                                                        onBlur={ handleBlur }
                                                        onChange={ handleChange }
                                                        disabled={ padre.nombre_completo?.length > 0 }
                                                        helperText={ touched.codigo_verificacion ? errors.codigo_verificacion : "" }
                                                        error={ touched.codigo_verificacion && Boolean( errors.codigo_verificacion ) }
                                                        autoComplete="off"
                                                        className={ classes.inputStyle } //agregado
                                                        />
                                                    :
                                                        null
                                                }
                                            </div>
                                            <div className={`${values.tipo_doc_padre === '0101'
                                                ? 
                                                    "s-y-4 s-x-2 s-cols-1    m-y-2 m-x-2 m-cols-1    l-y-1 l-x-9 l-cols-2"
                                                : 
                                                    "s-y-7 s-x-2 s-cols-1    m-y-3 m-x-2 m-cols-1    l-y-2 l-x-8 l-cols-2"}`}>
                                                {
                                                    values.tipo_doc_padre !== ''
                                                    ?
                                                        <div className={ classes.wrapper }>
                                                            {
                                                                ( captcha.imagen )
                                                                    ? <img src={ captcha.imagen } alt="captcha" style={{ maxWidth: '200%' }}/>
                                                                    : <CircularProgress size={30} className={ classes.captchaProgress } />
                                                            }
                                                        </div>
                                                    :
                                                        null
                                                }
                                            </div>
                                            <div className={`${values.tipo_doc_padre === '0101'
                                                ? 
                                                    "s-y-5 s-x-1 s-cols-2    m-y-2 m-x-4 m-cols-1    l-y-1 l-x-11 l-cols-2"
                                                : 
                                                    "s-y-8 s-x-1 s-cols-2    m-y-3 m-x-4 m-cols-1    l-y-2 l-x-10 l-cols-2"}`}>
                                                {/* <Tooltip title="Buscar en Reniec" arrow>
                                                    Aca va el botón
                                                </Tooltip> */}
                                                {
                                                    values.tipo_doc_padre !== ''
                                                    ?
                                                        <Button variant="contained" size="large" style={{ width: '100%' }}
                                                        type="submit" disabled={ !isValid || isSubmitting }
                                                        color="primary" startIcon={ <SearchIcon />}
                                                        className = { classes.buttonStyle }  >
                                                            Buscar..
                                                        </Button>
                                                    :
                                                        null
                                                }
                                                {/* startIcon={ <SearchIcon /> } */}
                                            </div>
                                        </>
                                    :
                                        <>
                                            {
                                                values.tipo_doc_padre === '0101'
                                                ?
                                                    <div className="s-y-4 s-x-1 s-cols-2 
                                                                    m-y-2 m-x-1 m-cols-2
                                                                    l-y-1 l-x-7 l-cols-3">
                                                        <MyField name="nombre_completo" />
                                                    </div>
                                                :
                                                    null
                                            }
                                            {/* className="s-y-5 s-x-1 s-cols-2 
                                                        m-y-2 m-x-4 m-cols-1
                                                        l-y-1 l-x-11 l-cols-2" */}


                                            {
                                                (values.tipo_doc_padre === '0101' )
                                                &&
                                                <div className="s-y-5 s-x-1 s-cols-2    m-y-2 m-x-3 m-cols-1    l-y-1 l-x-10 l-cols-1" >
                                                    <TextField className={ classes.inputStyle}
                                                    fullWidth
                                                    size="small"
                                                    label="Género"
                                                    id="genero"
                                                    name="genero"
                                                    variant="outlined" 
                                                    value={ padre.genero == 'M' ? 'Masculino' : 'Femenino' }
                                                    disabled
                                                    />
                                                </div>
                                            }


                                            <div className={ values.tipo_doc_padre === '0101' 
                                                            ? "s-y-6 s-x-1 s-cols-2    m-y-2 m-x-4 m-cols-1    l-y-1 l-x-11 l-cols-2"
                                                            : "s-y-6 s-x-1 s-cols-2    m-y-2 m-x-4 m-cols-1    l-y-1 l-x-12 l-cols-1" } >
                                                {/* <MyPhone name="celular" handleBlur={ handleBlur } 
                                                value={ values.celular }
                                                onChange={ ( { target } ) => {
                                                    if ( !target.value ) {
                                                        setFieldValue( "celular", '' )
                                                        dispatch( updatePadre( {celular: '' } ) )
                                                    }
                                                    else {
                                                        setFieldValue( "celular", target.value )
                                                        dispatch( updatePadre( {celular: target.value } ) )
                                                    }
                                                } } /> */}


                                                <TextField className={ classes.inputStyle}
                                                fullWidth
                                                size="small"
                                                label="Celular"
                                                id="celular"
                                                name="celular"
                                                variant="outlined" 
                                                value={ values.celular }
                                                onChange={ ( { target } ) => {
                                                    if ( !target.value ) {
                                                        setFieldValue( "celular", '' )
                                                        dispatch( updatePadre( {celular: '' } ) )
                                                    }
                                                    else {
                                                        setFieldValue( "celular", target.value )
                                                        dispatch( updatePadre( {celular: target.value } ) )
                                                    }
                                                } }
                                                onBlur={ handleBlur }
                                                InputProps={ { inputComponent: TextNumber } }
                                                autoComplete="off"
                                                />
                                            </div>
                                        </>
                                }
                            </div>

                            <Alerta state={ alert } handleClose={ handleCloseAlert }/>

                        </AccordionDetails>
                    
                        <Divider />
                        <StyledAccordionActions style={{ display: 'block'}}> 
                            <Typography className={ classes.heading }>
                                Datos utilizados únicamente por el programa Auditores Juveniles para validación de la información
                            </Typography>
                        </StyledAccordionActions>
                    </Accordion>

                </form>
            ) }
        </Formik>  
    )
}
